import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WistiaApiService {

  constructor(private http:HttpClient) { }

  getHegnaAssets():Observable<string>{
    return this.http.get<string>('/api/WistiaApi/Hegna');
  }

  getLtcTrainingAssets():Observable<any>{
    return this.http.get<string>('/api/WistiaApi/LtcTraining');
  }
}
